import ReactLogo from './react.png';
import NodeLogo from './node.png';
import MongoLogo from './mongo.png';
import DockerLogo from './docker.png';

import TSLogo from './typescript.png';
import NodeMailerLogo from './nodemailer.png';
import ExpressLogo from './express.png';
import StripeLogo from './stripe.png';

import JSLogo from './javascript.png';
import HTMLogo from './html.png';
import CSSLogo from './css.png';
import CSharpLogo from './csharp.png';
import UnityLogo from './unity.png';
import Love2DLogo from './love2d.png';

import JavaLogo from './java.png';
import PythonLogo from './python.png';
import ArduinoLogo from './arduino.png';
import RaspberryLogo from './raspberry.png';
import CLogo from './c.png';
import CPPLogo from './cpp.png';
import HaskellLogo from './haskell.png';
import SFMLogo from './sfml.png';
import GithubLogo from './github.png';
import RabbitLogo from './rabbit.png';
import AWSLogo from './aws.png';
import SQLogo from './sql.png';
import OctaveLogo from './octave.png';
import MatlabLogo from './matlab.png';
import AssemblyLogo from './assembly.png';

import SKlearnLogo from './sklearn.png';
import AnacondaLogo from './anaconda.png';
import TensorflowLogo from './tensorflow.png';
import GWTLogo from './gwt.png';
import JupyterLogo from './jupyter.png';
import OverleafLogo from './overleaf.png';
import LuaLogo from './lua.png';
import VercelLogo from './vercel.png';
import HerokuLogo from './heroku.png';
import EslintLogo from './eslint.png';
import PrettierLogo from './prettier.png';
import MaterialLogo from './material.png';
import RLogo from './r.png';
import FigmaLogo from './figma.png';
import ChakraUILogo from './chakra.png';
import GoogleAnalyticsLogo from './googleanalytics.png';
import KofiLogo from './kofi.png';
import RiotGamesLogo from './riotgames.png';

import BlenderLogo from './blender.png';
import DiscordLogo from './discord.jpg';
import TailwindLogo from './tailwind.png';
import ThreeJSLogo from './three.png';
import OpenAILogo from './openai.png';
import MySQLLogo from './mysql.png';
import KaedimLogo from '../../kaedim/kaedim.jpg';
import CypressLogo from './cypress.jpeg';
import JestLogo from './jest.png';
import CloudFlareLogo from './cloudflare.png';
import ElectronJSLogo from './electron.png';


import PyboyLogo from './pyboy.png';
import PyTorchLogo from './pytorch.png';

export const logos = [
  ReactLogo,
  NodeLogo,
  MongoLogo,
  DockerLogo,
  TSLogo,
  NodeMailerLogo,
  ExpressLogo,
  StripeLogo,
  JSLogo,
  HTMLogo,
  CSSLogo,
  CSharpLogo,
  UnityLogo,
  Love2DLogo,
  JavaLogo,
  PythonLogo,
  ArduinoLogo,
  RaspberryLogo,
  CLogo,
  CPPLogo,
  HaskellLogo,
  SFMLogo,
  GithubLogo,
  RabbitLogo,
  AWSLogo,
  SQLogo,
  OctaveLogo,
  MatlabLogo,
  AssemblyLogo,
  SKlearnLogo,
  AnacondaLogo,
  TensorflowLogo,
  GWTLogo,
  JupyterLogo,
  OverleafLogo,
  LuaLogo,
  VercelLogo,
  HerokuLogo,
  EslintLogo,
  PrettierLogo,
  MaterialLogo,
  RLogo,
  FigmaLogo,
  ChakraUILogo,
  GoogleAnalyticsLogo,
  KofiLogo,
  RiotGamesLogo,
  BlenderLogo,
  DiscordLogo,
  TailwindLogo,
  ThreeJSLogo,
  OpenAILogo,
  MySQLLogo,
  KaedimLogo,
  CypressLogo,
  JestLogo,
  CloudFlareLogo,
  ElectronJSLogo,
  PyboyLogo,
  PyTorchLogo
];

export const images = logos;